<template>
  <div>
    <span id="lms-manager__course">
      <course-section />
    </span>
    <span id="lms-manager__category">
      <category-section />
    </span>
    <span id="lms-manager__module">
      <module-section />
    </span>
    <span id="lms-manager__series">
      <series-section />
    </span>
    <span id="lms-manager__unit">
      <unit-section />
    </span>
    <span v-if="isCurrentUserSuperAdmin" id="lms-manager__quiz">
      <quiz-section />
    </span>
  </div>
</template>
<script>
import CourseSection from '../components/lms-admin/CourseSection.vue';
import CategorySection from '../components/lms-admin/CategorySection.vue';
import ModuleSection from '../components/lms-admin/ModuleSection.vue';
import UnitSection from '../components/lms-admin/UnitSection.vue';
import QuizSection from '../components/lms-admin/QuizSection';
import SeriesSection from '@/components/lms-admin/SeriesSection';
import { some as _some } from 'lodash-es';

export default {
  name: 'LmsAdmin',
  components: {
    SeriesSection,
    QuizSection,
    CourseSection,
    CategorySection,
    ModuleSection,
    UnitSection,
  },
  mounted() {
    this.fetchUsers();
    this.$_introLmsManager();
  },
  computed: {
    roles() {
      return this.$auth.user().roles;
    },
    isCurrentUserSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
  },
  methods: {
    fetchUsers() {
      this.$store
        .dispatch('salespersonsAndManagers/getSalespersonsAndManagers', {
          roles: ['manager', 'salesperson'],
        })
        .then(({ data }) => {
          this.$store.commit(
            'salespersonsAndManagers/setSalespersonsAndManagers',
            data
          );
        });
    },
  },
};
</script>
